import { render, staticRenderFns } from "./CopyDesk.vue?vue&type=template&id=aa1a1a9a&"
import script from "./CopyDesk.vue?vue&type=script&lang=js&"
export * from "./CopyDesk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports